import { Component, Input } from '@angular/core';
import { FilterDefault } from './filter-default';


@Component({
  selector: 'pgs-default-table-filter',
  template: `
    <ng-container [ngSwitch]="column.getFilterType()">
      <pgs-select-filter *ngSwitchCase="'list'"
                     [query]="query"
                     [ngClass]="inputClass"
                     [column]="column"
                     (filter)="onFilter($event)">
      </pgs-select-filter>
      <pgs-checkbox-filter *ngSwitchCase="'checkbox'"
                       [query]="query"
                       [ngClass]="inputClass"
                       [column]="column"
                       (filter)="onFilter($event)">
      </pgs-checkbox-filter>
      <pgs-completer-filter *ngSwitchCase="'completer'"
                        [query]="query"
                        [ngClass]="inputClass"
                        [column]="column"
                        (filter)="onFilter($event)">
      </pgs-completer-filter>
      <pgs-input-filter *ngSwitchDefault
                    [query]="query"
                    [ngClass]="inputClass"
                    [column]="column"
                    (filter)="onFilter($event)">
      </pgs-input-filter>
    </ng-container>
  `,
})
export class DefaultFilterComponent extends FilterDefault {
  @Input() query: string;
}
